import { computed, inject, Injectable, signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { TAB_VALUE } from 'src/app/shared/components/listing-page/listing-page.types';
import {
  chartAlarmSegmentsColors,
  createAlarmsBadgesFn
} from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.constants';
import { ListingPageModel } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { ListingPageModelAbstract } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model-abstract';
import { AlarmsListingTableComponent } from 'src/app/shared/components/listing-table/alarms-listing-table.component';
import { MapTileComponent } from 'src/app/shared/components/map/map.component';
import { ListingPageId } from '@portal/shared/components/listing-page/store/listing-page-store.types';
import { ListingPageModelRegistry } from '@portal/shared/components/listing-page/services/listing-page-model/listing-page-model-registry.service';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { OrderDirection } from 'src/app/pages/equipment/devices/components/devices.models';
import { isSingleCommodityClient } from 'src/app/pages/help-and-settings/user-settings/store/user-settings.reducer';
import { AlarmListingFieldName } from '../services/alarms.types';
import { AlarmsListingFiltersSourceService } from './alarms-listing-filters-source.service';
import { AlarmsListingDataSourceService } from './alarms-listing-data-source.service';
import { AlarmsListingExportConfigService } from './alarms-listing-export-config.service';
import { createAlarmsColumns } from './alarms-listing.columns';
import { ALARMS_DEFAULT_SEARCH_TYPE, ALARMS_SEARCH_TYPES } from './alarms-listing.search';
import { ALARMS_SORT_FIELD } from './alarms-listing.sort';

@Injectable()
export class AlarmsListingModelService extends ListingPageModelAbstract implements ListingPageModel {
  readonly listingPageModelRegistry = inject(ListingPageModelRegistry);
  readonly #isSingleCommodityClient = inject(Store).selectSignal(isSingleCommodityClient);

  readonly pageTitle = TranslateRegistry.get.ALARMS.TITLE.ALARMS;
  readonly searchTypeList = signal(ALARMS_SEARCH_TYPES);
  readonly selectedSearchType = signal(ALARMS_DEFAULT_SEARCH_TYPE);
  readonly sorting = signal({
    columnName: AlarmListingFieldName.DateTimeUtcUpdated,
    orderDirection: OrderDirection.DESC
  });
  readonly tableColumns = computed(() =>
    createAlarmsColumns({ isSingleCommodityClient: this.#isSingleCommodityClient() })
  );
  readonly filterSource = inject(AlarmsListingFiltersSourceService);
  readonly dataSource = inject(AlarmsListingDataSourceService);
  readonly exportConfig = inject(AlarmsListingExportConfigService);

  readonly chartSegmentsColors = chartAlarmSegmentsColors;
  readonly createBadgesFn = createAlarmsBadgesFn;
  readonly mapCmp = MapTileComponent;
  readonly tableCmp = AlarmsListingTableComponent;
  readonly defaultTab = TAB_VALUE.Table;
  readonly sortField = ALARMS_SORT_FIELD;

  get pageId(): ListingPageId {
    return ListingPageId.Alarms;
  }

  constructor() {
    super();
    this.listingPageModelRegistry.add(ListingPageId.Alarms, this);
  }
}
